export function toCamelCase(name) {
    return name.replace(/(-|^)(.)/g, function (match, dash, letter) {
        return letter.toUpperCase();
    });
}
// Converts a prop to an event name. Returns
// undefined if property is not an event.
export function getEventName(prop) {
    var m = prop.match(/^on([A-Z])(.*)$/);
    if (!m) {
        return;
    }
    return m[1].toLowerCase() + m[2];
}
// Pulled from preact-compat
// https://github.com/developit/preact-compat/blob/7c5de00e7c85e2ffd011bf3af02899b63f699d3a/src/index.js#L349
export function shallowEquals(a, b) {
    for (var i in a) {
        if (!(i in b)) {
            return false;
        }
    }
    for (var i in b) {
        if (a[i] !== b[i]) {
            return false;
        }
    }
    return true;
}
//# sourceMappingURL=utils.js.map